import * as React from 'react';
import {Subscription} from 'rxjs';

import './PaymentProcessing.css';

import {Config} from '../../Config';
import {CrossFrameCommunication} from '../../CrossFrameCommunication';
import {Logger} from '../../Logger';
import {PaymentController, PaymentStateObject} from '../../PaymentController';
import {HeartbeatLoader} from '../HeartbeatLoader';

import {DotLoader} from '../DotLoader';
import {QueryContext} from '../../api/QueryContext';

/**
 * Payment processing is the view used when the payment is being processed and when the payment is
 * showing the retry and cancel page.
 */
export class PaymentProcessing extends React.Component {
  /**
   * This can be used for Coinify.com or other partners who do not have their own confirmation page.
   * TODO: keep this for now, as we have discussed to add this.
   */
  /* private get shouldShowSuccessPage(): boolean {
    return false;
  }*/

  /**
   * This can be used for Coinify.com or other partners who do not have their own confirmation page.
   */
  private get shouldShowDeniedPage(): boolean {
    return true;
    // Config.shouldShowRetryCancelPage;
  }

  static contextType = QueryContext;

  // Icons
  public static ICON_NONE = 0;
  public static ICON_ERROR = 1;
  public static ICON_SUCCESS = 2;

  public static SUCCESS = true;
  public static DENIED = false;

  public static MSG_SUCCESS_CAPTION = 'Payment accepted';
  public static MSG_SUCCESS_LINE1 =
    'We are now processing your order and you will receive an e-mail when your order has been delivered.';
  public static MSG_SUCCESS_LINE2 = '';

  public static MSG_DENIED_CAPTION = 'Payment rejected';
  public static MSG_DENIED_LINE1 =
    'We were not able to process your payment and complete your order.';
  public static MSG_DENIED_LINE2A =
    'Please verify that you have provided the correct card information.';
  public static MSG_DENIED_LINE2B =
    'Please contact your bank to ensure the payment card is enrolled for 3D Secure.';

  public subscription: Subscription;

  public state = {
    lines: [],
    caption: '',
    icon: PaymentProcessing.ICON_NONE,
    paymentState: PaymentController.PAYMENT_STATE_PROCESSING,
    userClickedCancel: false,
  };

  public componentDidMount() {
    Logger.log('PaymentProcessing created', {
      shouldShowDeniedPage: this.shouldShowDeniedPage,
    });
    this.subscription = PaymentController.paymentState.subscribe(
      (payment: PaymentStateObject) => {
        Logger.log('PaymentProcessing payment state changed ', {payment});
        const paymentState = payment.state;
        this.setState({paymentState});

        if (paymentState === PaymentController.PAYMENT_STATE_SUCCESS) {
          // if ( !this.shouldShowSuccessPage ) {
          this.finalizePaymentSession(PaymentProcessing.SUCCESS);
          /*} else {
          this.showSuccessPage();
        } */
        } else if (
          paymentState === PaymentController.PAYMENT_STATE_FAILED ||
          paymentState === PaymentController.PAYMENT_STATE_DECLINED ||
          paymentState === PaymentController.PAYMENT_STATE_DECLINED_NO_3DS
        ) {
          if (!this.shouldShowDeniedPage) {
            // Just close the payment page.
            this.finalizePaymentSession(PaymentProcessing.DENIED);
          } else {
            // Show retry/cancel page with error message.
            this.showDeniedPage(payment.message);
          }
        }
      }
    );
  }

  public componentWillUnmount() {
    if (this.subscription) {
      this.subscription.unsubscribe();
      this.subscription = null;
    }
  }

  public render() {
    const renderIcon = (icon: number) => {
      return icon === PaymentProcessing.ICON_SUCCESS ? (
        <svg
          id='check'
          className='icon'
          width='55px'
          height='55px'
          viewBox='0 0 55 55'
          version='1.1'
          xmlns='http://www.w3.org/2000/svg'
        >
          <g id='Page-1' stroke='none' strokeWidth='1' fill='none' fillRule='evenodd'>
            <g id='Check'>
              <circle id='Oval' fill='#FFFFFF' cx='27.5' cy='27.5' r='23.5' />
              <path
                d='M45.8571429,21.6428571 C45.8571429,20.9761871 45.6428593,20.4285736 45.2142857,20 L41.9642857,16.7857143 C41.5119025,16.3333311 40.9761936,16.1071429 40.3571429,16.1071429 C39.7380921,16.1071429 39.2023832,16.3333311 38.75,16.7857143 L24.1785714,31.3214286 L16.1071429,23.25 C15.6547596,22.7976168 15.1190507,22.5714286 14.5,22.5714286 C13.8809493,22.5714286 13.3452404,22.7976168 12.8928571,23.25 L9.64285714,26.4642857 C9.21428357,26.8928593 9,27.4404729 9,28.1071429 C9,28.7500032 9.21428357,29.2857121 9.64285714,29.7142857 L22.5714286,42.6428571 C23.0238118,43.0952404 23.5595207,43.3214286 24.1785714,43.3214286 C24.8214318,43.3214286 25.3690454,43.0952404 25.8214286,42.6428571 L45.2142857,23.25 C45.6428593,22.8214264 45.8571429,22.2857175 45.8571429,21.6428571 Z M51.1785714,13.6785714 C53.6309646,17.8690686 54.8571429,22.4523561 54.8571429,27.4285714 C54.8571429,32.4047868 53.6309646,36.9940266 51.1785714,41.1964286 C48.7261782,45.3988305 45.3988305,48.7261782 41.1964286,51.1785714 C36.9940266,53.6309646 32.4047868,54.8571429 27.4285714,54.8571429 C22.4523561,54.8571429 17.8631163,53.6309646 13.6607143,51.1785714 C9.45831232,48.7261782 6.13096464,45.3988305 3.67857143,41.1964286 C1.22617821,36.9940266 0,32.4047868 0,27.4285714 C0,22.4523561 1.22617821,17.8631163 3.67857143,13.6607143 C6.13096464,9.45831232 9.45831232,6.13096464 13.6607143,3.67857143 C17.8631163,1.22617821 22.4523561,0 27.4285714,0 C32.4047868,0 36.9940266,1.22617821 41.1964286,3.67857143 C45.3988305,6.13096464 48.7261782,9.46426464 51.1785714,13.6785714 Z'
                id=''
                fill='#4CBA7A'
              />
            </g>
          </g>
        </svg>
      ) : (
        <svg
          id='cross'
          className='icon'
          width='55px'
          height='55px'
          viewBox='0 0 55 55'
          version='1.1'
          xmlns='http://www.w3.org/2000/svg'
        >
          <g id='Page-1' stroke='none' strokeWidth='1' fill='none' fillRule='evenodd'>
            <g id='Cross'>
              <circle id='Oval' fill='#FFFFFF' cx='27.5' cy='27.5' r='23.5' />
              <path
                d='M41.0357143,35.5 C41.0357143,34.8809493 40.8095261,34.3452404 40.3571429,33.8928571 L33.8928571,27.4285714 L40.3571429,20.9642857 C40.8095261,20.5119025 41.0357143,19.9761936 41.0357143,19.3571429 C41.0357143,18.7142825 40.8095261,18.1666689 40.3571429,17.7142857 L37.1428571,14.5 C36.6904739,14.0476168 36.1428604,13.8214286 35.5,13.8214286 C34.8809493,13.8214286 34.3452404,14.0476168 33.8928571,14.5 L27.4285714,20.9642857 L20.9642857,14.5 C20.5119025,14.0476168 19.9761936,13.8214286 19.3571429,13.8214286 C18.7142825,13.8214286 18.1666689,14.0476168 17.7142857,14.5 L14.5,17.7142857 C14.0476168,18.1666689 13.8214286,18.7142825 13.8214286,19.3571429 C13.8214286,19.9761936 14.0476168,20.5119025 14.5,20.9642857 L20.9642857,27.4285714 L14.5,33.8928571 C14.0476168,34.3452404 13.8214286,34.8809493 13.8214286,35.5 C13.8214286,36.1428604 14.0476168,36.6904739 14.5,37.1428571 L17.7142857,40.3571429 C18.1666689,40.8095261 18.7142825,41.0357143 19.3571429,41.0357143 C19.9761936,41.0357143 20.5119025,40.8095261 20.9642857,40.3571429 L27.4285714,33.8928571 L33.8928571,40.3571429 C34.3452404,40.8095261 34.8809493,41.0357143 35.5,41.0357143 C36.1428604,41.0357143 36.6904739,40.8095261 37.1428571,40.3571429 L40.3571429,37.1428571 C40.8095261,36.6904739 41.0357143,36.1428604 41.0357143,35.5 Z M51.1785714,13.6785714 C53.6309646,17.8690686 54.8571429,22.4523561 54.8571429,27.4285714 C54.8571429,32.4047868 53.6309646,36.9940266 51.1785714,41.1964286 C48.7261782,45.3988305 45.3988305,48.7261782 41.1964286,51.1785714 C36.9940266,53.6309646 32.4047868,54.8571429 27.4285714,54.8571429 C22.4523561,54.8571429 17.8631163,53.6309646 13.6607143,51.1785714 C9.45831232,48.7261782 6.13096464,45.3988305 3.67857143,41.1964286 C1.22617821,36.9940266 0,32.4047868 0,27.4285714 C0,22.4523561 1.22617821,17.8631163 3.67857143,13.6607143 C6.13096464,9.45831232 9.45831232,6.13096464 13.6607143,3.67857143 C17.8631163,1.22617821 22.4523561,0 27.4285714,0 C32.4047868,0 36.9940266,1.22617821 41.1964286,3.67857143 C45.3988305,6.13096464 48.7261782,9.46426464 51.1785714,13.6785714 Z'
                id=''
                fill='#D64343'
              />
            </g>
          </g>
        </svg>
      ); //
    };

    const {paymentState, caption, lines} = this.state;

    const renderLoader = paymentState === PaymentController.PAYMENT_STATE_PROCESSING;
    let renderResult =
      paymentState > PaymentController.PAYMENT_STATE_PROCESSING && !!caption;
    let renderFailed = false;

    if (renderResult) {
      if (paymentState === PaymentController.PAYMENT_STATE_SUCCESS) {
        renderResult = false; // Never show the success page. this.shouldShowSuccessPage;
      } else {
        // Failed
        renderResult = renderFailed = this.shouldShowDeniedPage;
        if (this.state.userClickedCancel) {
          renderResult = renderFailed = false;
        }
      }
    }
    const useHeartbeatLoader = Config.shouldUseHeartbeatLoader;

    return (
      <div className='payment-processing'>
        {renderLoader && (
          <div className='container grid column'>
            {useHeartbeatLoader ? (
              <HeartbeatLoader widthAndHeight={75} bgColor={'#004A7C'} />
            ) : (
              <DotLoader widthAndHeight={75} bgColor={'#004A7C'} />
            )}
          </div>
        )}

        {renderResult && (
          <div className='container grid column'>
            <div className='message-container'>
              {renderIcon(this.state.icon)}
              <h3 id='caption' className='caption'>
                {this.state.caption}
              </h3>
              {lines.map((x, i) => (
                <span key={i}>
                  {x}
                  <br />
                </span>
              ))}
            </div>
            {renderFailed && (
              <div className='grid row'>
                <button
                  className='button primary'
                  onClick={this.onRetryClickedInDeniedState}
                >
                  <span>Retry</span>
                </button>
                <button
                  className='button default'
                  onClick={this.onCancelClickedInDeniedState}
                >
                  <span>Cancel</span>
                </button>
              </div>
            )}
          </div>
        )}
      </div>
    );
  }

  /**
   * Shows a page to make it clear to the user that the transaction is denied.
   */
  private showDeniedPage(message: string) {
    let lines: string[];
    if (message?.length) {
      lines = message
        .trim()
        .split('\n')
        .filter((x) => x);
    } else {
      lines = [
        PaymentProcessing.MSG_DENIED_LINE1,
        this.state.paymentState === PaymentController.PAYMENT_STATE_DECLINED_NO_3DS
          ? PaymentProcessing.MSG_DENIED_LINE2B
          : PaymentProcessing.MSG_DENIED_LINE2A,
      ];
    }
    this.setState({
      lines,
      icon: PaymentProcessing.ICON_ERROR,
      caption: PaymentProcessing.MSG_DENIED_CAPTION,
    });
  }

  /**
   * Invoked when the payment has been processed and the transaction between the customers bank and PSP is done.
   */
  private finalizePaymentSession(wasSuccessful: boolean) {
    Logger.log('finalizePaymentSession;', wasSuccessful);
    const state = wasSuccessful ? 'success' : 'failed';
    if (this.context.returnUrl) {
      Logger.log('returnUrl present: ', this.context.returnUrl);
      window.location = (this.context.returnUrl + '?state=' + state) as any;
    } else {
      Logger.log('returnUrl NOT present: ');
      const evt = wasSuccessful
        ? CrossFrameCommunication.EVENT_COMPLETE_SUCCESS
        : CrossFrameCommunication.EVENT_COMPLETE_FAILED;
      CrossFrameCommunication.postMessage(
        CrossFrameCommunication.EVENT_TYPE_COMPLETE,
        evt
      );
    }
  }

  /**
   * Invoked when the user clicks retry.
   *
   * The payment attempt state is denied and the payment page is configured
   * to give the user the option to click retry or cancel after the attempt.
   * see: shouldShowDeniedPage
   */
  private onRetryClickedInDeniedState = () => {
    PaymentController.resetToRetry();
  };

  private onCancelClickedInDeniedState = () => {
    this.setState({userClickedCancel: true}, () =>
      this.finalizePaymentSession(PaymentProcessing.DENIED)
    );
  };
}
